import axiosInstance from './axios.service';

const getToken = () => {
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    const { token } = JSON.parse(userInfo);
    return token;
  }
  return null;
};

const settingsService = {
  getSettings: async () => {
    const { data } = await axiosInstance.get('/api/settings');
    return data;
  },

  updateSettings: async settingsData => {
    const { data } = await axiosInstance.put('/api/settings', settingsData);
    return data;
  },

  getSettingsByKey: async key => {
    const { data } = await axiosInstance.get(`/api/settings/${key}`);
    return data;
  },

  updateSettingsByKey: async (key, value) => {
    const { data } = await axiosInstance.put(`/api/settings/${key}`, { value });
    return data;
  },

  getEmailSettings: async () => {
    const { data } = await axiosInstance.get('/api/settings/emails');
    return data;
  },

  updateEmailSettings: async emails => {
    const { data } = await axiosInstance.put('/api/settings/emails', { newEmails: emails });
    return data;
  },

  getPublicSettings: async () => {
    const { data } = await axiosInstance.get('/api/settings/public');
    return data;
  },

  uploadSettingsImg: async formData => {
    const { data } = await axiosInstance.post('/api/settings/uploadSettingsImg', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  getColors: async () => {
    const { data } = await axiosInstance.get('/api/colors/current');
    return data;
  },

  updateColors: async colors => {
    const { data } = await axiosInstance.put('/api/colors', colors, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return data;
  },

  getEmailTemplates: async () => {
    const { data } = await axiosInstance.get('/api/settings/email-templates');
    return data;
  },

  updateEmailTemplates: async templates => {
    const { data } = await axiosInstance.put('/api/settings/email-templates', { templates });
    return data;
  },

  getHomeConfig: async () => {
    const { data } = await axiosInstance.get('/api/settings/home-config');
    return data;
  },
  updateHomeConfig: async payload => {
    const { data } = await axiosInstance.put('/api/settings', payload);
    return data;
  },
};

export default settingsService;
